// Make a video render its own FIRST FRAME as the (paused) poster, instead of a
// separate poster image or a black box.
//
// Appending the `#t=0.1` media fragment forces the browser to seek to ~0.1s and
// paint that frame even while the video is paused — this is the well-known fix
// for iOS Safari / Chrome, which otherwise show a blank/black frame until play.
// For autoplaying videos the 0.1s start offset is imperceptible.
export const withFirstFramePoster = (url) => {
  if (!url || typeof url !== 'string') return url;
  if (url.includes('#t=')) return url; // already has a time fragment
  return `${url}#t=0.1`;
};
